import { Login } from '@jobcost-monorepo/ui';

export default function SignInPage() {
  return <Login />;
}
